import { render, staticRenderFns } from "./CustomersExceptionsList.html?vue&type=template&id=67e84e2a&scoped=true&external"
import script from "./CustomersExceptionsList.js?vue&type=script&lang=js&external"
export * from "./CustomersExceptionsList.js?vue&type=script&lang=js&external"
import style0 from "./CustomersExceptionsList.scss?vue&type=style&index=0&id=67e84e2a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e84e2a",
  null
  
)

export default component.exports